/** @type {import('next-i18next').UserConfig} */
module.exports = {
  i18n: {
    defaultNS: 'common',
    defaultLocale: 'zh',
    locales: ['zh', 'cn'],
    reloadOnPrerender: true,
  },
};
